import api from '@/api'

import type { Placement } from '@/types/placement'

class PlacementService {
  getPlacements = async (bpId: number | null): Promise<Placement[]> => {
    const response = await api.get<{ data: Array<Record<string, unknown>> }>(
      `businessProfiles/${bpId}/PublishedTemplateConfigurations`,
    )

    const parsedConfigurations = response.data.map((config) => {
      const guidelines = JSON.parse(config.creativeSetGuidelines as string)
      return {
        ...config,
        creativeSetConfiguration: guidelines.CreativeSetConfiguration,
        creativeSetGuidelines: guidelines.ValidationGuidelines,
        publishedVariants: (config.publishedVariants as Array<Record<string, unknown>>).map(
          (variant) => ({
            id: variant.id,
            canvasJson: JSON.parse(variant.canvasJson as string),
          }),
        ),
      }
    })

    return parsedConfigurations as Placement[]
  }
}

export default PlacementService
